import React, { Component } from 'react';
import NavItemRight from '../../NavItemRight';
import NavItemLeft from '../../NavItemLeft';
import Button from '../../CustomButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faComment } from '@fortawesome/free-solid-svg-icons';
import './index.css';
import ShareButton from '../../ShareButton';



class BlogeContentHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.slideClickHandler = this.slideClickHandler.bind(this);
  }

  slideClickHandler(e, key){
    if(key !== 'view'){
      this.props.onClickSlide(e, key)
    } else {

    }
  }

  render() {
    const { lang, content, likes, comments } = this.props;
    return (
      <header className='blog-sbc-header-container'>
        <div className='blog-sbc-header-wrapper'>
          {content.headerImg}
          <div className='blog-sbc-header-img-shadow'></div>
          <div className='blog-sbc-header-top-layer-wrapper'>
            <div className='blog-sbc-header-top-layer-title'>
              <h1>{lang==='fa'? content.title.fa : content.title.en}</h1>
              <Button onClick={this.viewArticleClickHandler} className='transparent-white-opacity-button'> 
                {lang === 'fa' ? 'ادامه مطلب' : 'View Article'}
              </Button>
            </div>
            <div className='blog-sbc-header-top-layer-nav-item-right'>
              <NavItemRight onClick={this.slideClickHandler} lang={lang}/>
            </div>
            <div className='blog-sbc-header-top-layer-nav-item-left'>
              <NavItemLeft onClick={this.slideClickHandler} lang={lang}/>
            </div>
            <div className='blog-sbc-header-top-layer-slide-actions'>
              <div className='blog-sbc-header-top-layer-slide-actions-date'>date</div>
              <div className='blog-sbc-header-top-layer-slide-actions-socials'>
                <div className='blog-sbc-header-top-layer-slide-actions-socials-wrapper'>
                  <div>
                    <FontAwesomeIcon icon={faHeart} color="rgba(255, 255, 255, 0.5)" />
                    <span>{likes ? likes : 0} Like</span>
                  </div>
                  <div style={{marginRight:'20px'}}>
                    <FontAwesomeIcon icon={faComment} color="rgba(255, 255, 255, 0.5)" />
                    <span>{comments ? comments : 0} comments</span>
                  </div>
                </div>
                <div className='blog-sbc-header-top-layer-slide-actions-socials-share-btn'> 
                  <ShareButton lang={lang} vertical={false}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}



export default BlogeContentHeader;
